import {ACTION_TYPE} from "utils/constants";
import Command from "./command";

export function createActionStack({onChangeLength}) {
  const arr = [];
  if (!onChangeLength) return arr;
  Object.defineProperty(arr, "previousLength", {value: arr.length, writable: true, enumerable: false, configurable: false});
  const actionStack = new Proxy(arr, {
    set: (target, prop, value) => {
      if (prop === "length") {
        onChangeLength(target.previousLength, value);
        target.previousLength = value;
      }
      return Reflect.set(target, prop, value);
    },
  });
  return actionStack;
}

export function _undoRedo(context, action) {
  if (action.command === ACTION_TYPE.UNDO) {
    if (context.undo.length === 0) return;
    let lastCommand = context.undo.pop();
    context.redo.push(lastCommand);
    if (lastCommand.type === Command.typeTransform) {
      context.selected = undefined;
      if (lastCommand.target === "tempGroup") {
        context.selectObject(context.tempGroup);
      } else {
        context.selectObject(lastCommand.target);
      }
      context.selected.position.copy(lastCommand.preValue.position);
      context.selected.rotation.copy(lastCommand.preValue.rotation);
      context.selected.scale.copy(lastCommand.preValue.scale);
      context.selected.userData.positionX = lastCommand.preValue.position.x;
      context.selected.userData.positionY = lastCommand.preValue.position.y;
      context.selected.userData.positionZ = lastCommand.preValue.position.z;
      context.selected.userData.rotationX = lastCommand.preValue.rotation.x;
      context.selected.userData.rotationY = lastCommand.preValue.rotation.y;
      context.selected.userData.rotationZ = lastCommand.preValue.rotation.z;
      context.selected.userData.scaleX = lastCommand.preValue.scale.x;
      context.selected.userData.scaleY = lastCommand.preValue.scale.y;
      context.selected.userData.scaleZ = lastCommand.preValue.scale.z;
    } else if (lastCommand.type === Command.typeSpriteTransform) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.position.copy(lastCommand.preValue.position);
      context.selected.scale.copy(lastCommand.preValue.scale);
    } else if (lastCommand.type === Command.typeAdd) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.removeObject(lastCommand.target, true);
    } else if (lastCommand.type === Command.typeRemove) {
      context.postAddObject(lastCommand.target, lastCommand.parent, lastCommand.index, true);
      context.selectObject(lastCommand.target);
      context.dispatchEvent(
        new CustomEvent(ACTION_TYPE.OBJECT_ADDED, {
          detail: {object: lastCommand.target},
        }),
      );
    } else if (lastCommand.type === Command.typeReorder) {
      context.selectObject(lastCommand.target);
      lastCommand.preValue.parent.attach(context.selected);
      const position = context.selected.parent.children.indexOf(context.selected);
      context.selected.parent.children.splice(position, 1);
      context.selected.parent.children.splice(lastCommand.preValue.index, 0, context.selected);
    } else if (lastCommand.type === Command.typePosition) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.position.copy(lastCommand.preValue);
      context.selected.userData.positionX = lastCommand.preUserData.x;
      context.selected.userData.positionY = lastCommand.preUserData.y;
      context.selected.userData.positionZ = lastCommand.preUserData.z;
    } else if (lastCommand.type === Command.typeRotation) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.rotation.copy(lastCommand.preValue);
      context.selected.userData.rotationX = lastCommand.preUserData.x;
      context.selected.userData.rotationY = lastCommand.preUserData.y;
      context.selected.userData.rotationZ = lastCommand.preUserData.z;
    } else if (lastCommand.type === Command.typeScale) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.scale.copy(lastCommand.preValue);
      context.selected.userData.scaleX = lastCommand.preUserData.x;
      context.selected.userData.scaleY = lastCommand.preUserData.y;
      context.selected.userData.scaleZ = lastCommand.preUserData.z;
    } else if (lastCommand.type === Command.typeMaterialColor) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.color.setHex(lastCommand.preValue);
    } else if (lastCommand.type === Command.typeLightColor) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.color.setHex(lastCommand.preValue);
    } else if (lastCommand.type === Command.typeLightIntensity) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.intensity = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeLightDistance) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.distance = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeBlending) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.blending = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeOpacity) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.transparent = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeEmissiveIntensity) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.emissiveIntensity = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeEmissive) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.emissive = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMaterialOffsetX) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.map.offset.x = lastCommand.preValue;
      context.selected.material.normalMap.offset.x = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMaterialOffsetY) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.map.offset.y = lastCommand.preValue;
      context.selected.material.normalMap.offset.y = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMaterialRepeatX) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.map.repeat.x = lastCommand.preValue;
      context.selected.material.normalMap.repeat.x = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMaterialRepeatY) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.map.repeat.y = lastCommand.preValue;
      context.selected.material.normalMap.repeat.y = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMaterialRotation) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.map.rotation = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeShininess) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.shininess = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeSpotLightTargetX) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.target.position.x = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeSpotLightTargetY) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.target.position.y = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMap) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.map = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeNormalMap) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.normalMap = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeEnvMap) {
      context.selected = undefined;
      context.selectObject(lastCommand.target);
      context.selected.material.envMap = lastCommand.preValue;
    } else if (lastCommand.type === Command.typeMultiselectAdd) {
      context.selectMultipleObject(lastCommand.target, true);
    } else if (lastCommand.type === Command.typeMultiselectRemove) {
      context.selectMultipleObject(lastCommand.target, true);
    }
  } else if (action.command === ACTION_TYPE.REDO) {
    if (context.redo.length === 0) return;
    let nextCommand = context.redo.pop();
    context.undo.push(nextCommand);
    if (nextCommand.type === Command.typeTransform) {
      context.selected = undefined;
      if (nextCommand.target === "tempGroup") {
        context.selectObject(context.tempGroup);
      } else {
        context.selectObject(nextCommand.target);
      }
      context.selected.position.copy(nextCommand.postValue.position);
      context.selected.rotation.copy(nextCommand.postValue.rotation);
      context.selected.scale.copy(nextCommand.postValue.scale);
      context.selected.userData.positionX = nextCommand.postValue.position.x;
      context.selected.userData.positionY = nextCommand.postValue.position.y;
      context.selected.userData.positionZ = nextCommand.postValue.position.z;
      context.selected.userData.rotationX = nextCommand.postValue.rotation.x;
      context.selected.userData.rotationY = nextCommand.postValue.rotation.y;
      context.selected.userData.rotationZ = nextCommand.postValue.rotation.z;
      context.selected.userData.scaleX = nextCommand.postValue.scale.x;
      context.selected.userData.scaleY = nextCommand.postValue.scale.y;
      context.selected.userData.scaleZ = nextCommand.postValue.scale.z;
    } else if (nextCommand.type === Command.typeSpriteTransform) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.position.copy(nextCommand.postValue.position);
      context.selected.scale.copy(nextCommand.postValue.scale);
    } else if (nextCommand.type === Command.typeAdd) {
      context.postAddObject(nextCommand.target, nextCommand.parent, nextCommand.index, true);
      context.selectObject(nextCommand.target);
      context.dispatchEvent(
        new CustomEvent(ACTION_TYPE.OBJECT_ADDED, {
          detail: {object: nextCommand.target},
        }),
      );
    } else if (nextCommand.type === Command.typeRemove) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.removeObject(nextCommand.target, true);
    } else if (nextCommand.type === Command.typeReorder) {
      context.selectObject(nextCommand.target);
      nextCommand.postValue.parent.attach(context.selected);
      const position = context.selected.parent.children.indexOf(context.selected);
      context.selected.parent.children.splice(position, 1);
      context.selected.parent.children.splice(nextCommand.postValue.index, 0, context.selected);
    } else if (nextCommand.type === Command.typePosition) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.position.copy(nextCommand.postValue);
      context.selected.userData.positionX = nextCommand.postUserData.x;
      context.selected.userData.positionY = nextCommand.postUserData.y;
      context.selected.userData.positionZ = nextCommand.postUserData.z;
    } else if (nextCommand.type === Command.typeRotation) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.rotation.copy(nextCommand.postValue);
      context.selected.userData.rotationX = nextCommand.postUserData.x;
      context.selected.userData.rotationY = nextCommand.postUserData.y;
      context.selected.userData.rotationZ = nextCommand.postUserData.z;
    } else if (nextCommand.type === Command.typeScale) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.scale.copy(nextCommand.postValue);
      context.selected.userData.scaleX = nextCommand.postUserData.x;
      context.selected.userData.scaleY = nextCommand.postUserData.y;
      context.selected.userData.scaleZ = nextCommand.postUserData.z;
    } else if (nextCommand.type === Command.typeMaterialColor) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.color.setHex(nextCommand.postValue);
    } else if (nextCommand.type === Command.typeLightColor) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.color.setHex(nextCommand.postValue);
    } else if (nextCommand.type === Command.typeLightIntensity) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.intensity = nextCommand.postValue;
    } else if (nextCommand.type === Command.typeLightDistance) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.distance = nextCommand.postValue;
    } else if (nextCommand.type === Command.typeBlending) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.blending = nextCommand.postValue;
    } else if (nextCommand.type === Command.typeOpacity) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.transparent = nextCommand.postValue;
    } else if (nextCommand.type === Command.typeMaterialOffsetX) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.map.offset.x = nextCommand.preValue;
      context.selected.material.normalMap.offset.x = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeMaterialOffsetY) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.map.offset.y = nextCommand.preValue;
      context.selected.material.normalMap.offset.y = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeRepeatX) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.map.repeat.x = nextCommand.preValue;
      context.selected.material.normalMap.repeat.x = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeRepeatY) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.map.repeat.x = nextCommand.preValue;
      context.selected.material.normalMap.repeat.x = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeMaterialRotation) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.map.rotation = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeShininess) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.shininess = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeSpotLightTargetX) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.target.position.x = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeSpotLightTargetY) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.target.position.y = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeMap) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.map = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeNormalMap) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.normalMap = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeEnvMap) {
      context.selected = undefined;
      context.selectObject(nextCommand.target);
      context.selected.material.envMap = nextCommand.preValue;
    } else if (nextCommand.type === Command.typeMultiselectAdd) {
      context.selectMultipleObject(nextCommand.target, true);
    } else if (nextCommand.type === Command.typeMultiselectRemove) {
      context.selectMultipleObject(nextCommand.target, true);
    }
  }

  if (context.selected) {
    context.box.setFromObject(context.selected);
    if (context.box.isEmpty() === false) {
      context.selectionBox.setFromObject(context.selected);
      context.selectionBox.visible = true;
    }
    context.dispatchEvent(
      new CustomEvent(ACTION_TYPE.CHANGE_PROPERTY_FROM_SCENE, {
        detail: {object: context.selected},
      }),
    );
  }

  context.render();
}
